

export default {
  locale: 'tr',
  Pagination: {
    items_per_page: '/ sayfa',
    jump_to: 'Git',
    jump_to_confirm: 'onayla',
    page: 'Sayfa',
    prev_page: 'Önceki Sayfa',
    next_page: 'Sonraki Sayfa',
    prev_5: 'Önceki 5 Sayfa',
    next_5: 'Sonraki 5 Sayfa',
    prev_3: 'Önceki 3 Sayfa',
    next_3: 'Sonraki 3 Sayfa',
    page_size: 'sayfa boyutu'
  },
  DatePicker: {
    lang: {
      placeholder: 'Tarih seç',
      yearPlaceholder: 'Yıl seç',
      quarterPlaceholder: 'Çeyrek seç',
      monthPlaceholder: 'Ay seç',
      weekPlaceholder: 'Hafta seç',
      rangePlaceholder: ['Başlangıç tarihi', 'Bitiş tarihi'],
      rangeYearPlaceholder: ['Başlangıç yılı', 'Bitiş yılı'],
      rangeMonthPlaceholder: ['Başlangıç ayı', 'Bitiş ayı'],
      rangeWeekPlaceholder: ['Başlangıç haftası', 'Bitiş haftası'],
      locale: 'tr_TR',
      today: 'Bugün',
      now: 'Şimdi',
      backToToday: 'Bugüne Geri Dön',
      ok: 'tamam',
      clear: 'Temizle',
      month: 'Ay',
      year: 'Yıl',
      timeSelect: 'Zaman Seç',
      dateSelect: 'Tarih Seç',
      monthSelect: 'Ay Seç',
      yearSelect: 'Yıl Seç',
      decadeSelect: 'On Yıl Seç',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Önceki Ay (PageUp)',
      nextMonth: 'Sonraki Ay (PageDown)',
      previousYear: 'Önceki Yıl (Control + Sol)',
      nextYear: 'Sonraki Yıl (Control + Sağ)',
      previousDecade: 'Önceki On Yıl',
      nextDecade: 'Sonraki On Yıl',
      previousCentury: 'Önceki Yüzyıl',
      nextCentury: 'Sonraki Yüzyıl'
    },
    timePickerLocale: {
      placeholder: 'Zaman seç',
      rangePlaceholder: ['Başlangıç zamanı', 'Bitiş zamanı']
    }
  },
  TimePicker: {
    placeholder: 'Zaman seç',
    rangePlaceholder: ['Başlangıç zamanı', 'Bitiş zamanı']
  },
  Calendar: {
    lang: {
      placeholder: 'Tarih seç',
      yearPlaceholder: 'Yıl seç',
      quarterPlaceholder: 'Çeyrek seç',
      monthPlaceholder: 'Ay seç',
      weekPlaceholder: 'Hafta seç',
      rangePlaceholder: ['Başlangıç tarihi', 'Bitiş tarihi'],
      rangeYearPlaceholder: ['Başlangıç yılı', 'Bitiş yılı'],
      rangeMonthPlaceholder: ['Başlangıç ayı', 'Bitiş ayı'],
      rangeWeekPlaceholder: ['Başlangıç haftası', 'Bitiş haftası'],
      locale: 'tr_TR',
      today: 'Bugün',
      now: 'Şimdi',
      backToToday: 'Bugüne Geri Dön',
      ok: 'tamam',
      clear: 'Temizle',
      month: 'Ay',
      year: 'Yıl',
      timeSelect: 'Zaman Seç',
      dateSelect: 'Tarih Seç',
      monthSelect: 'Ay Seç',
      yearSelect: 'Yıl Seç',
      decadeSelect: 'On Yıl Seç',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Önceki Ay (PageUp)',
      nextMonth: 'Sonraki Ay (PageDown)',
      previousYear: 'Önceki Yıl (Control + Sol)',
      nextYear: 'Sonraki Yıl (Control + Sağ)',
      previousDecade: 'Önceki On Yıl',
      nextDecade: 'Sonraki On Yıl',
      previousCentury: 'Önceki Yüzyıl',
      nextCentury: 'Sonraki Yüzyıl'
    },
    timePickerLocale: {
      placeholder: 'Zaman seç',
      rangePlaceholder: ['Başlangıç zamanı', 'Bitiş zamanı']
    }
  },
  global: {
    placeholder: 'Lütfen seçiniz'
  },
  Table: {
    filterTitle: 'Filtre menüsü',
    filterConfirm: 'Tamam',
    filterReset: 'Sıfırla',
    filterEmptyText: 'Filtre yok',
    selectAll: 'Tüm sayfayı seç',
    selectInvert: 'Tersini seç',
    selectionAll: 'Tümünü seç',
    sortTitle: 'Sırala',
    expand: 'Satırı genişlet',
    collapse: 'Satırı daralt',
    triggerDesc: 'Azalan düzende sırala',
    triggerAsc: 'Artan düzende sırala',
    cancelSort: 'Sıralamayı kaldır'
  },
  Modal: {
    okText: 'Tamam',
    cancelText: 'İptal',
    justOkText: 'Tamam'
  },
  Popconfirm: {
    okText: 'Tamam',
    cancelText: 'İptal'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Arama',
    itemUnit: 'Öğe',
    itemsUnit: 'Öğeler',
    remove: 'Kaldır',
    selectCurrent: 'Tüm sayfayı seç',
    removeCurrent: 'Sayfayı kaldır',
    selectAll: 'Tümünü seç',
    removeAll: 'Tümünü kaldır',
    selectInvert: 'Tersini seç'
  },
  Upload: {
    uploading: 'Yükleniyor...',
    removeFile: 'Dosyayı kaldır',
    uploadError: 'Yükleme hatası',
    previewFile: 'Dosyayı önizle',
    downloadFile: 'Dosyayı indir'
  },
  Empty: {
    description: 'Veri Yok'
  },
  Icon: {
    icon: 'ikon'
  },
  Text: {
    edit: 'Düzenle',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    expand: 'Genişlet'
  },
  PageHeader: {
    back: 'Geri'
  },
  Image: {
    preview: 'Önizleme'
  }
};
